export const BOOLEAN_VALUE_STRING = {
    true: "true",
    false: "false",
};

export const TOKEN_FIELD = "Authorization";

export const PAGE_FIELD = "page";
export const LIMIT_FIELD = "per_page";
export const TYPE_FIELD = "type";

export const METHOD_GET = "GET";
export const METHOD_POST = "POST";
export const METHOD_PUT = "PUT";
export const METHOD_DELETE = "DELETE";

export const EMPTY_STRING = "";
export const EMPTY_FUNC = () => {};

export const MODAL_TYPE = {
    view: "view",
    create: "create",
    edit: "edit",
    delete: "delete",
};

export const MODAL_DOC_TYPE = {
    document: "document",
    signed_document: "signed_document",
};

export const TAGS_TYPE = {
    doc: 0,
    consumption: 1,
};

export const dayArr = ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"];
